import "../Styles/Employee_sign.css";
import { Link } from "react-router-dom";
import { useState, useRef } from "react";

const Employee_sign = () => {
  const otpRef = useRef([]);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [step, setStep] = useState("role");
  // role | join | welcome

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/, "");

    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (index < 3) {
      otpRef.current[index + 1].focus();
    }
  };

  const handleOtpBackspace = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) {
        otpRef.current[index - 1].focus();
      }
    }
  };
  return (
    <div className="employee-wrapper">
      <div className="employee-header">
        <div className="header-left">
          <img
            src={require("../assests/images/agent-login-signup-top-logo.png")}
            alt="Logo"
            className="header-logo"
          />
        </div>
        <div className="header-right">
          <span className="header-signup ">Agent Sign up</span>
          <div className="underline-for-agent"></div>
        </div>
      </div>

      <div className="emp">
        <div className="employee-container">
          {/* ROLE SCREEN */}
          {step === "role" && (
            <>
              <img
                src={require("../assests/images/employee_sign-up-profile.png")}
                alt="Profile"
              />
              <h2>Choose your role </h2>
              <div
                className="underline-for-agent   mt-0"
                style={{ width: "10%" }}
              ></div>
              <div className="employee-roles">
                <div
                  className="role-card"
                  onClick={() =>
                    alert("Employee functionality is coming soon!")
                  }
                >
                  <div>
                    <div className="role-header-title">Employee</div>
                  </div>
                  <div className="employee-desc">
                    Connect to your company using your company code
                  </div>
                </div>

                <Link
                  to="/business_setup"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <div className="role-card-owner">
                    <div>
                      <div className="role-header-title">Owner</div>
                    </div>

                    <div className="employee1-desc">
                      Set up business profile and invite your employees
                    </div>
                  </div>
                </Link>
              </div>
            </>
          )}

          {/* JOIN COMPANY */}
          {step === "join" && (
            <>
              <h2>Join company</h2>
              <p>
                Are you part of a registered company? Join using company code
              </p>

              <div className="code-boxes">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (otpRef.current[index] = el)}
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleOtpBackspace(e, index)}
                  />
                ))}
              </div>

              <button
                className="email-submit"
                onClick={() => setStep("welcome")}
              >
                Join →
              </button>
            </>
          )}

          {/* WELCOME */}
          {step === "welcome" && (
            <>
              <h2>Welcome Aboard</h2>
              <p>On last step enter your name to finish setup</p>

              <input className="welcome-input" placeholder="Enter Your name" />

              <button className="email-submit">Finish →</button>
            </>
          )}
        </div>
      </div>

      <div className="emp_footer_line"></div>
    </div>
  );
};

export default Employee_sign;
